import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-message",
  "use": "icon-message-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-message\"><defs><style type=\"text/css\"></style></defs><path d=\"M945.493333 889.6h-853.333333a42.666667 42.666667 0 0 1-42.666667-42.666667v-682.666666a42.666667 42.666667 0 0 1 42.666667-42.666667h853.333333a42.666667 42.666667 0 0 1 42.666667 42.666667v682.666666a42.666667 42.666667 0 0 1-42.666667 42.666667z m-810.666666-85.333333h768v-597.333334h-768z\" p-id=\"7289\" fill=\"#ffffff\" /><path d=\"M518.826667 548.266667a42.666667 42.666667 0 0 1-26.88-9.386667l-426.666667-341.333333a42.666667 42.666667 0 0 1-13.653333-47.786667 42.666667 42.666667 0 0 1 42.666666-28.16h853.333334a42.666667 42.666667 0 0 1 40.106666 28.16 42.666667 42.666667 0 0 1-13.653333 47.786667l-426.666667 341.333333a42.666667 42.666667 0 0 1-28.586666 9.386667zM213.333333 206.933333l305.066667 243.626667 305.066667-243.626667z\" p-id=\"7290\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/message.svg
// module id = G2zY
// module chunks = 102